export const TRANSFORM_PROPERTIES = [
    'scaleX',
    'scaleY',
    'scaleZ',
    'scale',
    'translate',
    'translateX',
    'translateY',
    'translateZ',
    'rotate',
    'rotateX',
    'rotateY',
    'rotateZ',
    'skew',
    'skewX',
    'skewY'
];

export const AUTO_PROPERTIES = [
    'width',
    'height',
    'margin',
    'top',
    'right',
    'bottom',
    'left'
];

export const RESIZE_PROPERTIES = [
    'width', 'height'
];

export const DEFAULT_UNIT_SUFFIXES = {
    'width': 'px',
    'height': 'px',
    'margin': 'px',
    'top': 'px',
    'right': 'px',
    'left': 'px',
    'bottom': 'px',
    'padding': 'px',
    'scaleX': '',
    'scaleY': '',
    'scaleZ': '',
    'scale': '',
    'translate': 'px',
    'translateX': 'px',
    'translateY': 'px',
    'translateZ': 'px',
    'rotate': 'deg',
    'rotateX': 'deg',
    'rotateY': 'deg',
    'rotateZ': 'deg',
    'skew': 'deg',
    'skewX': '',
    'skewY': '',
    'backgroundPosition': 'px',
    'borderWidth': 'px',
    'borderBottom-width': 'px',
    'borderTopWidth': 'px',
    'borderLeftWidth': 'px',
    'borderRightWidth': 'px',
    'lineHeight': 'px',
    'maxHeight': 'px',
    'maxHidth': 'px',
    'minHeight': 'px',
    'minHidth': 'px',
    'fontSize': 'px',
    'fontWeight': '',
    'markerOffset': 'px',
    'marginTop': 'px',
    'marginRight': 'px',
    'marginBottom': 'px',
    'marginLeft': 'px',
    'paddingTop': 'px',
    'paddingRight': 'px',
    'paddingBottom': 'px',
    'paddingLeft': 'px',
    'outlineWidth': 'px',
    'letterSpacing': 'px',
    'textIndent': 'px',
    'wordSpacing': 'px',
    'opacity': ''
};